<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{ appConfig.ux.loadingMsg }}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar>
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-table
                #dt
                [value]="planList"
                [columns]="cols"
                dataKey="id"
                selectionMode="multiple"
                [(selection)]="planesSeleccionados"
                [rowHover]="true"
                [rows]="10"
                [paginator]="true"
                [scrollable]="true"
                scrollHeight="600px"
                [filterDelay]="0"
                [globalFilterFields]="['name', 'description', 'precio', 'minimoComprobantes', 'maximoComprobantes']"
                sortMode="multiple"
                [multiSortMeta]="multiSortMeta"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <button
                            pButton
                            type="button"
                            label="{{ appConfig.ux.actions.create }}"
                            icon="pi pi-plus"
                            (click)="nuevoPlan()">
                            <!--[disabled]="!puedeEjecutar('crear')"-->
                        </button>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input
                                pInputText
                                type="text"
                                (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="Buscar.." />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 3rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>

                    <th style="width: 6rem"
                        *ngFor="let col of columns"
                        [pSortableColumn]="col.field"
                        [hidden]="!col.visible"
                        [ngClass]="col.class">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </div>
                    </th>
                    <th style="width: 6rem">Acciones</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td style="width: 3rem">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td>
                    <td style="width: 6rem"
                        *ngFor="let col of columns" [hidden]="!col.visible" [ngClass]="col.class">
                        <span> {{ rowData[col.field] }}</span>
                    </td>
                    <td style="width: 6rem">
                    <p-button
                        pTooltip="{{ appConfig.ux.actions.actions }}"
                        tooltipPosition="bottom"
                        styleClass="p-button-rounded p-button-text p-button-sm"
                        (click)="presentarOpcionesActionSheet($event, rowData); op.toggle($event)">
                        <ng-template pTemplate="content"><img alt="acciones" src="assets/layout/icons/tap.png" style="width: 2rem" />
                        </ng-template>
                    </p-button>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<!---Diálogo de acciones--->
<p-overlayPanel #op 
                [style]="{ width: '15vw' }"
                [showCloseIcon]="false">
    <ng-template pTemplate>
        <div class="p-fluid p-formgrid p-grid">
            <button
                *ngFor="let item of buttonsActions; let i = index"
                pButton
                type="button"
                [label]="item.text"
                [icon]="item.icon"
                [class]="item.cssClass"
                (click)="ejecutarAccion($event, item.action, item.data); op.hide($event)"
                [disabled]="item.disabled"></button>
        </div>
    </ng-template>
</p-overlayPanel>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd header="Confirmación" icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button
            pButton
            type="button"
            label="No"
            icon="pi pi-times"
            class="p-button-secondary"
            (click)="cd.reject()"></button>
        <button pButton type="button" label="Sí" icon="pi pi-check" class="p-ml-2" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog
    [(visible)]="procesando"
    modal="modal"
    showEffect="fade"
    [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
    [style]="{ width: '90vw' }"
    (onHide)="procesando = false">
    <ng-template pTemplate="header">
        <h4>{{ appConfig.ux.loadingMsg }}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar>
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="p-text-uppercase">{{ appConfig.app.name }}</span>
    </ng-template>
</p-dialog>


<!-- Diálogos de creación/edición de plan -->
<p-dialog
    [header]="plan && plan.id ? 'Editar Plan' : 'Nuevo Plan'"
    [(visible)]="mostrarEditor && plan"
    modal="modal"
    showEffect="fade"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    [style]="{ width: '75vw' }"
    (onHide)="this.mostrarEditor = false">
    <form
        #planEditorForm="ngForm"
        (ngSubmit)="guardarInformacion(planEditorForm)"
        [ngClass]="{ disabledForm: false }">
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12">
            </div>
            <div class="field col-12">
                <label for="nombre">Nombre de Plan</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-bookmark"></i>
                    <input
                        #nombre ="ngModel"
                        id="nombre"
                        name="nombre"
                        type="text"
                        [(ngModel)]="plan.name"
                        [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                        required
                        pInputText 
                        />
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeMultilineTextPattern']"
                    *ngIf="
                    planEditorForm.controls['nombre'] &&
                    !planEditorForm.controls['nombre'].valid &&
                    (planEditorForm.controls['nombre'].dirty || planEditorForm.controls['nombre'].touched)
                    ">
                </p-message>
            </div>
            <div class="field col-12">
                <label for="tipoPlanfrm">Tipo</label>
                <p-selectButton 
                    #tipoPlanfrm="ngModel" id="tipoPlanfrm" name="tipoPlanfrm" 
                    [options]="tiposPlan" 
                    [(ngModel)]="tipoPlan" 
                    optionLabel="name" optionValue="value"
                    required>
                </p-selectButton>
            </div>
            <div class="field col-12">
                <label for="precio">Precio</label>
                <p-inputNumber 
                    #precio ="ngModel"
                    id="precio"
                    name="precio"
                    [(ngModel)]="plan.precio"
                    [showButtons]="true" 
                    inputId="precio"    
                    mode="currency"                    
                    currency="USD"
                    [required]="true">
                </p-inputNumber>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeMultilineTextPattern']"
                    *ngIf="
                    planEditorForm.controls['precio'] &&
                    !planEditorForm.controls['precio'].valid &&
                    (planEditorForm.controls['precio'].dirty || planEditorForm.controls['precio'].touched)
                    ">
                </p-message>
            </div>
            <div class="field col-12 md:col-6">
                <label for="stacked">Min. Comprobantes</label>
                <p-inputNumber 
                    #min ="ngModel"
                    id="min"
                    name="precio"
                    [(ngModel)]="plan.minimoComprobantes"
                    [showButtons]="true" 
                    inputId="withoutgrouping" 
                    [useGrouping]="false"
                    mode="decimal"
                    [required]="true">
                </p-inputNumber>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeMultilineTextPattern']"
                    *ngIf="
                    planEditorForm.controls['min'] &&
                    !planEditorForm.controls['min'].valid &&
                    (planEditorForm.controls['min'].dirty || planEditorForm.controls['min'].touched)
                    ">
                </p-message>
            </div>
            <div class="field col-12 md:col-6">
                <label for="stacked">Max. Comprobantes</label>
                <p-inputNumber 
                    #max ="ngModel"
                    id="max"
                    name="max"
                    [(ngModel)]="plan.maximoComprobantes"
                    [showButtons]="true" 
                    inputId="withoutgrouping" 
                    [useGrouping]="false"
                    mode="decimal"
                    [required]="true">
                </p-inputNumber>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeMultilineTextPattern']"
                    *ngIf="
                    planEditorForm.controls['max'] &&
                    !planEditorForm.controls['max'].valid &&
                    (planEditorForm.controls['max'].dirty || planEditorForm.controls['max'].touched)
                    ">
                </p-message>
            </div>
            <div class="field col-12">
                <label for="tipo">Período</label>
                <div id="tipo" clas="text-center">
                    <div *ngFor="let item of tiposPeriodo" class="field-checkbox inline-flex px-4">
                        <p-radioButton [inputId]="item.value" name="item" [value]="item" 
                                       [(ngModel)]="tipo" 
                                       [disabled]="false">
                        </p-radioButton>
                        <label [for]="item.value">{{item.name}}</label>
                    </div>
                </div>
            </div>
            <div class="field col-12 md:col-6 align-self-center text-center">
                <label for="visibleWebfrm"><strong>¿Es visible para la WEB?</strong></label>
                <p-inputSwitch 
                    #visibleWebfrm="ngModel" inputId="visibleWebfrm" name="visibleWebfrm" 
                    [(ngModel)]="plan.visibleWeb"
                    class="ml-2">
                </p-inputSwitch>
            </div>
            <div class="field col-12 md:col-6 align-self-center text-center">
                <label for="visiblePreciofrm"><strong>¿Es visible su precio?</strong></label>
                <p-inputSwitch 
                    #visiblePreciofrm="ngModel" inputId="visiblePreciofrm" name="visiblePreciofrm" 
                    [(ngModel)]="plan.visiblePrecio"
                    class="ml-2">
                </p-inputSwitch>
            </div>
            <div class="p-field col-12 p-md-12">
                <label for="nombre">Descripción</label>
                <span class="p-input-icon-left">
                    <i class="pi pi-bookmark"></i>
                    <textarea #description="ngModel" id="description" 
                              name="description" type="text"
                              [(ngModel)]="plan.description" 
                              [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                              [rows]="3"
                              placeholder="Descripción del plan..."
                              [disabled]="false"
                              pInputTextarea></textarea>
                </span>
                <p-message
                    severity="error"
                    [text]="appConfig['validationMsgs']['safeMultilineTextPattern']"
                    *ngIf="
                    planEditorForm.controls['description'] &&
                    !planEditorForm.controls['description'].valid &&
                    (planEditorForm.controls['description'].dirty || planEditorForm.controls['description'].touched)
                    ">
                </p-message>
            </div>
        </div>
        <p-footer>
            <div class="flex align-items-center justify-content-end">
                <button
                    pButton
                    type="button"
                    label="{{ appConfig.ux.actions.cancel }}"
                    icon="pi pi-times"
                    class="p-button-secondary"
                    (click)="this.mostrarEditor = false"></button>
                <button
                    pButton
                    type="submit"
                    label="{{ appConfig.ux.actions.save }}"
                    icon="pi pi-check"
                    class="p-ml-lg-1"
                    [disabled]="!planEditorForm.valid"></button>
            </div>
        </p-footer>
    </form>
</p-dialog>
